module.exports = __webpack_public_path__ + "media/images/new-team-icon-d0b33072.png";